import ScormAPI from '@/lib/ScormApi/ScormAPI'
import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'

export {
  ScormAPI,
  ScormAPI2004
}
